import { LanguageCode } from "@bto/shared";
import { fetchOrLogout } from "./helpers";
import { getBaseUrl } from "./requestUtils";

export type ReportDownloadLocation = "grid" | "report_screen";
export type ReportDownloadType = "carrier" | "aneuploidy" | "cfc";

const endpointByType: Record<ReportDownloadType, string> = {
  carrier: "unityreports",
  aneuploidy: "aneuploidyreports",
  cfc: "cfcreports",
};

const downloadLocationReportKindByType: Record<ReportDownloadType, string> = {
  carrier: "unity",
  aneuploidy: "aneuploidy",
  cfc: "cfc",
};

/**
 * Fetches a signed download URL for a carrier, aneuploidy, or CFC report.
 */
export const fetchReportDownloadUrl = async (
  token: string,
  reportType: ReportDownloadType,
  reportID: string,
  setLoggedOut: (inactivity: boolean) => void,
  downloadLocation: ReportDownloadLocation,
  language?: LanguageCode,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  const languageParam = language ? `language=${language}&` : "";
  const reportKind = downloadLocationReportKindByType[reportType];
  return fetchOrLogout(
    `${baseUrl}/api/v1/${endpointByType[reportType]}/${reportID}/download/?${languageParam}download_location=provider_${reportKind}_${downloadLocation}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );
};

export const fetchReportPreviewPdf = async (
  token: string,
  reportType: ReportDownloadType,
  reportID: string,
  setLoggedOut: (inactivity: boolean) => void,
  options: { language?: LanguageCode; signal?: AbortSignal } = {},
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  const { language, signal } = options;
  const languageParam = language ? `?language=${language}` : "";
  return fetchOrLogout(
    `${baseUrl}/api/v1/${endpointByType[reportType]}/${reportID}/preview/${languageParam}`,
    {
      method: "GET",
      signal,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );
};
